/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-09-18 12:00:42
 * @LastEditors: liuziwei
 * @Description: 券浮层 - list
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-list-container">
    <!-- 可领取券之结界  包含待领取和待解锁 -->
    <view wx:if="{{unclaimed.length||unlock.length}}" class="unclaimed-area">
      <!-- 结界介绍 -->
      <view class="unclaimed-title">
        <text class="title-text">可领取的优惠券</text>
        <view class="unclaimed-btn" bindtap="receiveAllCoupon" wx:if="{{unclaimed.length>0}}">全部领取</view>
      </view>
      <!-- 券列表 -->
      <!-- 未领取 -->
      <coupon-item
        wx:for="{{unclaimed}}"
        couponData="{{item}}"
        bind:receiveSingleCoupon="receiveSingleCoupon"
        isUnclaimed="{{true}}"
      />
      <!-- 待解锁 -->
      <coupon-item
        wx:for="{{unlock}}"
        couponData="{{item}}"
        bind:receiveSingleCoupon="receiveSingleCoupon"
        isUnlock="{{true}}"
      />
    </view>
    <!-- 已领取券之结界 -->
    <view wx:if="{{received.length}}" class="received-area">
      <!-- 结界介绍 -->
      <view class="received-title">
        <text class="title-text">已领取的优惠券</text>
        <text class="received-tip">满足使用条件即可使用</text>
      </view>
      <coupon-item wx:for="{{received}}" couponData="{{item}}" isReceived="{{true}}"/>
    </view>
  </view>
</template>

<script>
  import { couponFromConf, bannerFromConf, couponStatusConf } from '@/config/coupon'
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { receiveFlightsCoupon } from '@/utils/flights-coupon'
  import { trackEvent } from '@/common/track'
  import { sendEvent, debounce } from '@/utils'
  import { locate, goTo } from '@didi/webx-js'


  createComponent({
    props: {
      bannerFrom: {
        type: String,
        value: () => ''
      },
      activityId: {
        type: String | Number,
        value: () => ''
      },
      received: {
        type: Array,
        value: () => []
      },
      unclaimed: {
        type: Array,
        value: () => []
      },
      unlock: {
        type: Array,
        value: () => []
      },
      cityId: {
        type: String | Number,
        value: () => ''
      }
    },
    attached() {
      const allConpons = this.received?.concat?.(this.unclaimed)?.concat?.(this.unlock)
      // 埋点参数
      const detail = allConpons?.map((item) => {
        const coupon = item?.coupon_info
        return {
          pope_id: this.activityId,
          batch_id: coupon?.batch_id,
          status: coupon?.couponStatusInfo?.status
        }
      })
    },
    methods: {
      // 领取单张券
      receiveSingleCoupon: debounce(
        function ({ type, detail }) {
          if (type === 'receiveSingleCoupon') {
            const curCoupon = detail?.coupon ?? {}
            const curCouponStatus = curCoupon?.couponStatusInfo?.status
            // 点击埋点
            trackEvent('yks_plane_home_couponfloat_receive_ck', '迎客松-机票-首页-领券浮层-立即领取-点击', {
              coupon: curCoupon?.batchId,
              page: 'home',
            })
            // 如果券状态为已抢光, 提示明日再来
            // if (Number(curCouponStatus) === couponStatusConf.noStock.status) {
            //   return mpx?.showToast?.({ title: '券已抢光啦！明天早点来领吧～' })
            // }
            // // 如果券今日已被领过, 不可再领
            // if (curCoupon?.stock_has_received) {
            //   return mpx?.showToast?.({ title: '今日已达领取上限' })
            // }
            // 领取优惠券

            receiveFlightsCoupon({
              params: {
                cityId: this.cityId,
                couponInfo: [{
                  batchId: curCoupon?.batchId,
                  orderId: curCoupon?.orderId
                }],
              },
              cb: this.receiveCB()
            })
          }
        },
        500,
        true
      ),
      // 领取全部券
      receiveAllCoupon: debounce(
        function () {
          //未领取优惠券的id数组
          const orderIdArr = this.unclaimed?.map((item) => ({
            orderId: item?.orderId,
            batchId: item?.batchId,
          }))
          // const detail = this.unclaimed?.map((item) => {
          //   const coupon = item?.coupon_info
          //   return {
          //     pope_id: this.activityId,
          //     batch_id: coupon?.batch_id,
          //     status: coupon?.couponStatusInfo?.status
          //   }
          // })
          // const notHasStock = this.unclaimed?.some((item) => !item?.coupon_info?.has_stock)
          // const title = notHasStock ? '券已抢光啦！明天早点来领吧～' : '今日已达领取上限'
          // // 没有券就不要领了
          // if (!receiveUrls.length) return mpx.showToast({ title: title })
          // 点击埋点
          trackEvent('yks_plane_home_couponfloat_allreceive_ck', '迎客松-机票-首页-领券浮层-全部领取-点击', {
            page: 'home', // 全领
            coupon: orderIdArr.map(({batchId}) => batchId).join(',')
          })
          receiveFlightsCoupon({
            params: {
              cityId: this.cityId,
              couponInfo: orderIdArr
            },
            cb: this.receiveCB()
          })
        },
        500,
        true
      ),
      // 领券回调
      receiveCB() {
        switch (this.bannerFrom) {
          case bannerFromConf?.home:
            return () => sendEvent('updateFlightsHomePage')
          case bannerFromConf?.tickets:
            return () => sendEvent('updateTrainList')
          default:
            return () => {}
        }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-list-container
    width 100%
    box-sizing border-box
    background #F6F8FB
    transform translateY(-20px)
    .title-text
      font-family PingFang SC
      font-size 14px
      font-weight 600
      color #333
    .received-area
      background #fff
      padding 20px 15px
      .received-title
        display flex
        align-items center
        padding-bottom 15px
        .received-tip
          font-family PingFang SC
          font-size 12px
          font-weight 400
          color #999
          margin-left 5px
    .unclaimed-area
      background #fff
      padding 20px 15px
      margin-bottom 7px
      .unclaimed-title
        display flex
        align-items center
        justify-content space-between
        margin-bottom 15px
        .unclaimed-btn
          width 85px
          height 27px
          border-radius 13.5px
          background linear-gradient(270deg, #FF4A4E 0%, #FF712E 100%)
          font-family PingFang SC
          font-size 13px
          font-weight 500
          line-height 11px
          color #fff
          display flex
          align-items center
          justify-content center
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'coupon-item': './coupon-item'
    }
  }
</script>
